import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
// import "primereact/resources/themes/vela-orange/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import axios from "axios";
import { Image } from "primereact/image";
import { Button } from "primereact/button";
import { NodeData } from "../types/types";

const UnsplashImagePicker: React.FC<{
  imagePickerVisible: boolean;
  selectedNode: { id: string; data: NodeData } | null;
  nodes: Array<{ id: string; data: NodeData }>;
  setNodes: React.Dispatch<
    React.SetStateAction<Array<{ id: string; data: NodeData }>>
  >;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
  setImagePickerVisible: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
  imagePickerVisible,
  selectedNode,
  nodes,
  setNodes,
  setIsDirty,
  setImagePickerVisible,
}) => {
  const env_unsplashAccessKey = import.meta.env.VITE_UNSPLASH_ACCESS_KEY;
  const API_URL = "https://api.unsplash.com/search/photos";
  const IMAGES_PER_PAGE = 20;
  const [searchText, setSearchText] = useState<string | null>(null);
  const searchInput = useRef<HTMLInputElement>(null);
  interface UnsplashImage {
    id: string;
    urls: {
      small: string;
      thumb: string;
      regular: string;
      full: string;
      raw: string;
      small_s3: string;
    };
    alt_description: string;
  }

  const [images, setImages] = useState<UnsplashImage[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);

  const resetSearch = () => {
    setPage(1);
    fetchImages();
  };

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (searchInput.current) {
      console.log(searchInput.current.value);
      resetSearch();
    }
  };

  // const handleSelection = (selection: string) => {
  //   if (searchInput.current) {
  //     searchInput.current.value = selection;
  //   }
  //   fetchImages();
  // };

  const fetchImages = async () => {
    try {
      if (!searchInput.current || searchInput.current.value === "") {
        return;
      }
      const { data } = await axios.get(
        `${API_URL}?query=${
          searchInput.current?.value || ""
        }&page=${page}&per_page=${IMAGES_PER_PAGE}&client_id=${env_unsplashAccessKey}`
      );
      console.log("images", data);
      setImages(data.results);
      setTotalPages(data.total_pages);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchImages();
  }, [page]);

  return (
    <div>
      <div className="" style={{ overflow: "hidden", padding: "0px" }}>
        <div
          className="search-section"
          style={{
            margin: "0 10px",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <h4 style={{ textAlign: "center", margin: "0px 0px 20px 0px" }}>
            Image Search
          </h4>
          <div
            className="search-bar"
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "0px 0px 20px 0px",
              overflow: "hidden",
            }}
          >
            <InputText
              type="search"
              placeholder="Type something to search..."
              className="search-input"
              style={{ width: "50%", fontSize: "14px" }}
              ref={searchInput}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(
                    e as unknown as React.FormEvent<HTMLFormElement>
                  );
                }
              }}
            />
          </div>
          {/* <div className="filters">
            <div onClick={() => handleSelection("nature")}>Nature</div>
            <div onClick={() => handleSelection("birds")}>Birds</div>
            <div onClick={() => handleSelection("cats")}>Cats</div>
            <div onClick={() => handleSelection("shoes")}>Shoes</div>
          </div> */}
        </div>
        <div
          className="images"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            height: "calc(100vh - 430px)",
            overflowY: "auto",
          }}
        >
          {images.map((image) => {
            return (
              <Image
                key={image.id}
                src={image.urls.small}
                alt={image.alt_description}
                className="image"
                width="300"
                style={{ cursor: "pointer", margin: "5px" }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null; // prevents looping
                  target.src = "https://via.placeholder.com/200"; // fallback image
                }}
                onLoad={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.opacity = "1"; // show the image when loaded
                }}
                onClick={() => {
                  if (selectedNode) {
                    const updatedNodes = nodes.map((node) => {
                      if (node.id === selectedNode.id) {
                        return {
                          ...node,
                          data: {
                            ...node.data,
                            icon: image.urls.small,
                          },
                        };
                      }
                      return node;
                    });
                    setNodes(updatedNodes);
                    setIsDirty(true);
                    setImagePickerVisible(false);
                  }
                }}
              />
            );
          })}
        </div>
      </div>
      <div
        className="buttons"
        style={{
          textAlign: "center",
          marginTop: "20px",
          padding: "0px",
          position: "absolute",
          bottom: "10px",
          width: "100%",
        }}
      >
        {page > 1 && (
          <Button onClick={() => setPage(page - 1)} style={{ margin: "10px" }}>
            Previous
          </Button>
        )}
        {page < totalPages && (
          <Button onClick={() => setPage(page + 1)} style={{ margin: "10px" }}>
            Next
          </Button>
        )}
      </div>
    </div>
  );
};

export default UnsplashImagePicker;
